import { createCrewLookupSelect } from './createCrewLookupSelect';

export const AvailabilityStatusSelect = createCrewLookupSelect(
  'AvailabilityStatusSelect',
  'availabilityStatuses',
);
export default AvailabilityStatusSelect;
